export default __webpack_public_path__ + "static/affiliate-program-Software-1@2x-349fa7e2a90228c27a796d21f311d7a7.png";